module.exports = __webpack_public_path__ + "static/Q2Answer1_Nothingfearless_KamilPietrzak-05725a9c894f3edbda2c72eea15d7a56.jpg";